// WarrantyHistoryReportPage.jsx
import React from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import useVehicleServiceData from './hook/useVehicleServiceReportData';
import VehicleServiceReportTable from './component/VehicleServiceReportTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportVehicleServiceToExcelQuery } from '../../../api/endpoints/vehicleServiceReport';

const VehicleServiceReportPage = () => {
    const { th } = useLanguage();
    const { apiData, isLoading, lazyParams, sortField, sortOrder, activeFilters, onPage, onSort, handleFilterChange, initFilters, exportParams,isDealer } = useVehicleServiceData();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('vehicleServiceReport.title')}</h1>{' '}
                <div className="flex gap-2">
                    {' '}
                    <Button icon="pi pi-filter-slash" className="p-button-outlined p-button-secondary" onClick={initFilters} tooltip={th('filter.reset')} tooltipOptions={{ position: 'left' }} />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportVehicleServiceToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel="Excel"
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'Araç Servis Giriş Raporu.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
                </div>
            </div>
            <VehicleServiceReportTable
                items={apiData?.items ?? []}
                totalCount={apiData?.totalCount ?? 0}
                loading={isLoading}
                lazyParams={lazyParams}
                onPage={onPage}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
                isDealer={isDealer}
            />
        </div>
    );
};

export default VehicleServiceReportPage;